// extracted by mini-css-extract-plugin
module.exports = {"title":"_2aYMy___Buildings-module__title","cardList":"_39Kfk___Buildings-module__cardList"};